export const incomingRequests = {

  "title": "Slimme matching",
  "subtitle": "Ontdek leden die uw regio willen bezoeken",
  "requests": {
    "title": "Aanvragen",
    "count": "{{count}} aanvraag/aanvragen",
    "empty": {
      "noListingDescription": "Je hebt nog geen advertentie. Publiceer er een om aanvragen te ontvangen."
    },
    "loading": "Aanvragen laden...",
    "errors": {
      "notAuthenticated": "Je moet ingelogd zijn om deze pagina te bekijken.",
      "loadFailed": "Er is een fout opgetreden bij het laden van de aanvragen."
    },
    "defaultPropertyType": "Accommodatie",
    "sortOptions": {
      "recent": "Meest recente",
      "rating": "Beste beoordeeld",
      "distance": "Dichterbij"
    }
  },
  "aiSection": {
    "title": "Slimme suggesties",
    "subtitle": "Ontdek leden die aan uw criteria voldoen",
    "distance": "Afstand",
    "dates": "Data",
    "guests": "Reizigers",
    "matchScore": "Compatibiliteitsscore",
    "search": "Zoeken",
    "startDiscussion": "Gesprek starten",
    "viewProfile": "Bekijk profiel",
    "away": "afstand"
  }
};
